import React, { Component } from 'react';
import { connect } from 'react-redux';
import determinarPaginaAtualSelecaoEmpresa from '../../actions/selecao-empresa/determinarPaginaAtualSelecaoEmpresa';

import BotoesPaginacao from '../comum/BotoesPaginacao';

export class SetasPaginacaoSelecaoEmpresa extends Component {
  render () {
    if (this.props.empresas.length === 0) {
      return '';
    }

    return <BotoesPaginacao
      numeroElementos={this.props.empresas.length}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualSelecaoEmpresa}/>;
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualSelecaoEmpresa,
    empresas: state.authentication.empresasSelecao,
    registrosPorPagina: state.registrosPorPaginaSelecaoEmpresa
  };
}

export default connect(mapStateToProps, { determinarPaginaAtualSelecaoEmpresa })(SetasPaginacaoSelecaoEmpresa);
